<template>
	<div>
		<v-snackbar v-model="snackbar.show" top :color="snackbar.color">
			{{snackbar.message}}
			<v-btn :color="snackbar.buttonColor" flat @click="snackbar.show = false">
				Close
			</v-btn>
		</v-snackbar>

		<loading-modal v-if="isLoading" loading-text="Loading Policy..." />

		<hr-document v-else-if="hrDocument" :hr-document="hrDocument" 
			:logged-in-tenant="loggedInTenant" 
			:logged-in-employee="loggedInEmployee"
			:is-admin="loggedInEmployee.isAdmin" 
			:is-agreeing="isAgreeing" 
			:load-update="loadUpdate"
			@onAgree="onAgree"
			@onUpdate="loadDocument" />

		<v-footer color="" app height="55" class="noPrint">
			<v-spacer></v-spacer>
			<footer-back-btn @click="onBackClick">Back to Policies</footer-back-btn>
		</v-footer>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import HrDocument from '@/components/hrDocuments/HrDocument';
	import LoadingModal from '@/components/LoadingModal';

	export default {
		props: {
			id: {
				required: true
			},
			loadUpdate: {
				type: Boolean,
				default: false
			}
		},
		components: {
			HrDocument,
			LoadingModal
		},
		data() {
			return {
				snackbar: {
					show: false,
					message: '',
					color: undefined,
					buttonColor: 'pink'
				},
				isAgreeing: false,
				hrDocument: null,
				isLoading: false
			};
		},
		created() {
			this.$store.dispatch('setPageTitle', this.$term('companyPolicy', { case: 'title' }));

			this.loadDocument();
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				loggedInTenant: 'loggedInTenant'
			})
		},
		methods: {
			loadDocument(snackbarMessage) {
				if (snackbarMessage) {
					this.showSnackbar(snackbarMessage);
				}
				this.isLoading = true;
				return this.$store.dispatch('hrDocuments/getById', this.id).then(
					(hrDocument) => {
						this.isLoading = false;
						this.hrDocument = hrDocument;
					},
					(error) => {
						this.isLoading = false;
						this.showSnackbar('An error occurred loading document', true);
					}
				);
			},
			showSnackbar(message, isError) {
				this.snackbar.show = true;
				this.snackbar.message = message;
				this.snackbar.color = isError ? 'error' : 'undefined';
				this.snackbar.buttonColor = isError ? '#fff' : 'pink';
				this.snackbar.timeout = isError ? 0 : 6000
			},
			onAgree(agreementData) {
				this.isAgreeing = true;

				const data = {
					id: this.hrDocument.id,
					employeeId: this.loggedInEmployee.id,
					acknowledgementTextOption: agreementData.acknowledgementTextOption,
					acknowledgementText: agreementData.acknowledgementText
				}

				this.$store.dispatch('hrDocuments/postAgreement', data).then(
				response => {
					this.loadDocument().then(() => {
						this.isAgreeing = false;
						this.showSnackbar('You have successfully acknowledged the contents of this policy');
					})
				},
				err => {
					this.isAgreeing = false;
					this.showSnackbar('An error has occurred', true);
				}
				);
			},
			onBackClick() {
				this.$router.push(`/hrDocuments/policies/`);
			}
		}
	};
</script>

<style></style>
